import { render, staticRenderFns } from "./ProductionTabs.vue?vue&type=template&id=4cb7b390"
import script from "./ProductionTabs.vue?vue&type=script&lang=js"
export * from "./ProductionTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports